<template>
    <svg
        class="kkmenudown"
        width="16px"
        height="8px"
        viewBox="0 0 16 8"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="Component"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
        >
            <g
                id="Component-Guideline"
                transform="translate(-413.000000, -4142.000000)"
                :fill="color"
                fill-rule="nonzero"
            >
                <g
                    id="All_nomal,press"
                    transform="translate(341.000000, 4134.000000)"
                >
                    <g id="Path-2" transform="translate(72.000000, 8.000000)">
                        <path
                            d="M0,0 L2.83718022,0 L7.27334278,5.19614756 C7.67466448,5.67369814 8.32533552,5.67369814 8.72665722,5.19614756 L13.2015872,0 L16,0 L10.1799716,6.92551119 C8.97600655,8.35816294 7.02399345,8.35816294 5.82002835,6.92551119 L0,0 Z"
                            id="03_wu_arrow_normal_press"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'kk-menu-down',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
    },
};
</script>
